import React from "react";
import { Mail, MessageSquare, MapPin } from "lucide-react";
import Shell from "@/pages/LegalShell";

const Contact = () => (
  <Shell title="Contact" kicker="Talk to us — no bots" testid="contact-page" path="/contact">
    <p>
      ClydeFlow is run by a small team that actually picks up.
    </p>
    <div className="grid sm:grid-cols-2 gap-4 mt-6">
      <a
        href="mailto:hello@clydeflow.com"
        data-testid="contact-email"
        className="p-5 bg-[#0A192F] border border-white/10 hover:border-cyan-400/50 rounded-sm flex items-start gap-3"
      >
        <Mail size={20} className="text-cyan-300 mt-1" />
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-400">Email</p>
          <p className="text-white mt-1 font-semibold">hello@clydeflow.com</p>
        </div>
      </a>
      <a
        href="https://wa.me/441410000000"
        target="_blank"
        rel="noreferrer"
        data-testid="contact-whatsapp"
        className="p-5 bg-[#0A192F] border border-white/10 hover:border-cyan-400/50 rounded-sm flex items-start gap-3"
      >
        <MessageSquare size={20} className="text-cyan-300 mt-1" />
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-400">WhatsApp</p>
          <p className="text-white mt-1 font-semibold">Glasgow team · 9am–6pm BST</p>
        </div>
      </a>
      <div
        data-testid="contact-address"
        className="p-5 bg-[#0A192F] border border-white/10 rounded-sm flex items-start gap-3 sm:col-span-2"
      >
        <MapPin size={20} className="text-cyan-300 mt-1" />
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-400">HQ</p>
          <p className="text-white mt-1 font-semibold">Glasgow, Scotland</p>
        </div>
      </div>
    </div>
  </Shell>
);

export default Contact;
